//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "UiLazyImg",
  props: {
    useCdnOptimize: {
      type: Boolean,
      default: true
    },
    srcPlaceholder: {
      type: String,
      default: 'blank=width[1],height[1],color[none]&sink=format[gif]'
    },
    src: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      default: ''
    }
  },
  watch: {
    src(val) {
      this.updateImage(true);
    },
    showOptimizeImage(val) {
      this.$nextTick(() => {
        this.updateImage(true);
      })
    }
  },
  computed: {
    isAbsoluteImage() {
      return /^https?:\/\//i.test(this.src);
    },
    fullSrcPlaceholder() {
      return this.srcPlaceholder ? `https://${this.$config.CDN_OPTIMIZE_DOMEN}/${this.$config.CDN_OPTIMIZE_URI}?${this.srcPlaceholder}` : '';
    },
    showOptimizeImage() {
      return this.$config.CDN_OPTIMIZE_DOMEN && this.useCdnOptimize && this.isAbsoluteImage;
    }
  },
  methods: {
    updateImage(force = false) {
      if (this.showOptimizeImage) {
        window.imageResolver?.updateImage(this.$refs.img, force);
      }
    }
  },
  mounted() {
    this.updateImage();
  }
};
